import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
};

const filterSlice = createSlice({
  initialState,
  name: "filter",
  reducers: {
    filterProject: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filterProject } = filterSlice.actions;

export const filterSelector = (state) => state.filter.searchTerm;
